export interface MerchantConfig {
  id: string
  name: string
  shopFront: string
  characterImage: string
  portraitImage: string
}

export const merchants: Record<string, MerchantConfig> = {
  weaponsmith: {
    id: "goofy",
    name: "Zippy Xanax",
    shopFront: "/images/shop-front.png",
    characterImage: "/images/shopkeep-1-character.png",
    portraitImage: "/images/shopkeep-1.png",
  },
  mystic: {
    id: "surfer",
    name: "Reef Hightide",
    shopFront: "/images/shop-front-3.png",
    characterImage: "/images/shopkeep-2-character.png",
    portraitImage: "/images/shopkeep-2.png",
  },
  collector: {
    id: "accountant",
    name: "Fiscal Phil",
    shopFront: "/images/shop-front-4.png",
    characterImage: "/images/shopkeep-4-character.png",
    portraitImage: "/images/shopkeep-4.png",
  },
  apothecary: {
    id: "salesman",
    name: "Andy Arbitrage",
    shopFront: "/images/shop-front-2.png",
    characterImage: "/images/shopkeep-3-character.png",
    portraitImage: "/images/shopkeep-3.png",
  },
}

export const getMerchantList = (): MerchantConfig[] => {
  return Object.values(merchants)
}

export const getRandomMerchant = (): MerchantConfig => {
  const merchantList = getMerchantList()
  return merchantList[Math.floor(Math.random() * merchantList.length)]
}
